import React from "react";

import { makeStyles } from "@material-ui/core/styles";
const height = "32px";
const optionFocus = {
  backgroundColor: "var(--color-pale-teal)",
  borderColor: "transparent",
};
const dropdownFont = {
  font: "var(--size-14px) / var(--size-20px) var(--font-family-noto-sans)",
};
const dropdownStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: "var(--color-white)",
    padding: theme.spacing(2),
    width: "300px",
    minHeight: "800px",
    display: "flex",
    flexDirection: "column",
    outline: "none",
    overflow: "hidden",
    margin: "0px",
  },
  input: {
    backgroundColor: "var(--color-white)",
    border: "0.5px solid var(--color-medium-grey)",
    borderRadius: "2px",
    height: height,
    fontSize: "14px",
    boxSizing: "content-box",
    "&:hover": {
      backgroundColor: "var(--color-pale-grey)",
    },
    "&:focus-within": {
      backgroundColor: "var(--color-white)",
      border: "0.5px solid var(--color-light-teal)",
      boxShadow: "0px 0px 8px var(--color-shadow-primary)",
      "MuiIconButton-root": {
        display: "none",
      },
    },
    "& .Mui-error": {
      border: "0.5px solid var(--color-red)",
      boxShadow: "0px 0px 8px var(--color-shadow-red)",
    },
    "& .MuiChip-root": {
      height: "auto",
    },
    "& .MuiTypography-body1": {
      width: "1200px",
      overflow: "scroll",
      height: height,
      padding: "5px",
    },
  },
  textfield: {
    ...dropdownFont,
    height: height,
    fontSize: 14,
    color: "var(--color-primary-black)",
    "&.Mui-disabled": {
      backgroundColor: "var( --color-light-grey)",
      WebkitTextFillColor: "#636363",
      color:"#636363",
      height: height,
    },
  },
  placeHolder: {
    ...dropdownFont,
    paddingLeft: "10px",
  },
  option: {
    ...dropdownFont,
    color: "var(--color-medium-grey)",
    paddingLeft: "10px",
    minHeight: "auto",
    fontSize: "12px",

    '&[data-focus="true"]': optionFocus,
    '&[aria-selected="true"]': optionFocus,
  },
}));

export default dropdownStyles;
